const AppConfig = {
  PathApi: "https://service-api.ohbo1.com/api/server/connect",
  WalletApi: "https://service-wallet.ohbo1.com/NVSB/BOWallet",
};
export default AppConfig;
